import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Pagination } from '../../../../components/Pagination';
import './TablaAccesosProducto.css';
import { State } from "../../../../reducers";
import { actionsGPAgregarProducto } from "../../../../actions/action-creators";
import { gp_ap_SetSucursalesSeleccionadas } from "../../../../actions/gestion-producto/agregar-producto/agregarProducto.actions";

const TablaAccesosProducto = () => {
  const dispatch = useDispatch();
  const acciones = bindActionCreators(actionsGPAgregarProducto, dispatch);

  const dataSucursales = useSelector(
    (state: State) => state.gestionProducto.agregarProducto.catalogos.sucursales
  );
  const sucursalesSeleccionadasStore = useSelector(
    (state: State) => state.gestionProducto.agregarProducto.sucursalesAsignadas
  );

  // Estado local de selección
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  // Estado local de sucursales filtradas y paginadas
  const [allFiltered, setAllFiltered] = useState<any[]>([]);
  const [currentItems, setCurrentItems] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);

  // Filtrar solo sucursales activas y no eliminadas
  const sucursalesFiltradas = dataSucursales.filter(
    (s: any) =>
      (s.activo === true || s.activo === "true") &&
      (s.eliminado === 0 || s.eliminado === "0")
  );

  // Cargar sucursales al montar
  useEffect(() => {
    acciones.gp_ap_getSucursales();
  }, []);

  // Inicializar filtradas y paginación
  useEffect(() => {
    setAllFiltered(sucursalesFiltradas);
    setCurrentItems(sucursalesFiltradas.slice(0, 15));
  }, [sucursalesFiltradas]);

  // Inicializar selección solo al abrir modal / cargar datos
  useEffect(() => {
    if (sucursalesSeleccionadasStore.length > 0) {
      setSelectedRows(sucursalesSeleccionadasStore.map(id => id.toString()));
    } else {
      setSelectedRows([]);
    }
  }, [sucursalesSeleccionadasStore.length]); // NOTA: solo depende de la longitud

  // Guardar selección en el store cuando cambie localmente
  useEffect(() => {
    dispatch(gp_ap_SetSucursalesSeleccionadas(selectedRows));
  }, [selectedRows]);

  // Checkbox individual
  const handleCheckboxChange = (event: any, rowId: number) => {
    const idStr = rowId.toString();
    if (event.target.checked) {
      setSelectedRows(prev => [...prev, idStr]);
    } else {
      setSelectedRows(prev => prev.filter(id => id !== idStr));
    }
  };

  // Checkbox seleccionar todo
  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    if (newSelectAll) {
      setSelectedRows(allFiltered.map(s => s.idsucursal.toString()));
    } else {
      setSelectedRows([]);
    }
  };

  return (
    <div className='tab-plane mt-16'>
      <table className='ta-cu-table-main-responsive ta-cu-responsive-table-main td-left table-pointer'>
        <thead>
          <tr>
            <td>
              <label className='w-checkbox' style={{ marginLeft: '3%' }}>
                <input
                  type='checkbox'
                  checked={allFiltered.length > 0 && selectedRows.length === allFiltered.length}
                  onChange={handleSelectAll}
                  disabled={allFiltered.length === 0}
                />
                <div className='checkbox__checkmark'></div>
                <div className='checkbox__body' style={{ fontWeight: '400' }}>
                  No. Sucursal
                </div>
              </label>
            </td>
            <td>Nombre</td>
            <td>Dirección</td>
            <td>Código</td>
          </tr>
        </thead>
        <tbody>
          {currentItems.length === 0 ? (
            <tr>
              <td colSpan={5} style={{ textAlign: 'center', padding: '20px 0px' }}>
                No hay sucursales activas para asignar al producto
              </td>
            </tr>
          ) : (
            currentItems.map((sucursal, index) => (
              <tr
                key={sucursal.idsucursal}
                className={selectedRows.includes(sucursal.idsucursal.toString()) ? 'row-selected' : ''}
              >
                <td data-label='No. Sucursal'>
                  <label className='w-checkbox' style={{ marginLeft: '3%' }}>
                    <input
                      type='checkbox'
                      checked={selectedRows.includes(sucursal.idsucursal.toString())}
                      onChange={(e) => handleCheckboxChange(e, sucursal.idsucursal)}
                    />
                    <div className='checkbox__checkmark'></div>
                    <div className='checkbox__body fw-400'>{index + 1}</div>
                  </label>
                </td>
                <td data-label='Nombre'>{sucursal.nombre}</td>
                <td data-label='Dirección'>{sucursal.direccion}</td>
                <td data-label='Código'>{sucursal.codigo}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <Pagination
        data={allFiltered}
        state={(items: any[]) => setCurrentItems(items)}
        items={15}
      />
    </div>
  );
};

export default TablaAccesosProducto;
